import React, { useContext } from "react";
import moment from "moment";
import { descend, prop, sortWith } from "ramda";
import { InlineWaiting } from "components/ui";
import { PatientProfileContext } from "components/profile/context";
import { productLineNameForId } from "utils/walk-in-orders";

// Newest first, matching the previous Redux selector's ordering.
const sortByNewest = sortWith([descend(prop("order_date"))]);

const WalkInOrdersTab = () => {
  const { fetchPatientWalkInOrdersAPI } = useContext(PatientProfileContext);
  const { response: walkInOrders, isFetching } = fetchPatientWalkInOrdersAPI;

  if (isFetching) return <InlineWaiting reason="Loading walk-in orders" />;

  const rows = sortByNewest(walkInOrders ?? []);

  if (rows.length === 0) return <div>No walk-in orders.</div>;

  return (
    <div>
      <table className="large-12">
        <thead>
          <tr>
            <td>Date Created</td>
            <td>Product Line</td>
            <td>User</td>
          </tr>
        </thead>
        <tbody>
          {rows.map((walkIn, i) => (
            <tr key={walkIn.id ?? i}>
              <td>
                <span
                  data-tooltip
                  tabIndex={i}
                  title={moment(walkIn.order_date).format(
                    "MMM DD, YYYY -  hh:mm A"
                  )}
                >
                  {moment(walkIn.order_date).format("LL")}
                </span>
              </td>
              <td>{productLineNameForId(walkIn.product_line)}</td>
              <td>{walkIn.user_name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WalkInOrdersTab;
